export default __webpack_public_path__ + "static/media/bayc.9dff0147.png";